import { GlobalsAction } from './globals.action';

export class GlobalsState {
    public liveIsAttached: boolean;
}

export const initialState: GlobalsState = {
    liveIsAttached: true,
};

export function GlobalsReducer(state: GlobalsState = initialState, action?: GlobalsAction) {

    switch (action.type) {
        case GlobalsAction.attachLiveVideo:
            return { ...state, ...{ liveIsAttached: true } };

        case GlobalsAction.dettachLiveVideo:
            return { ...state, ...{ liveIsAttached: false } };

        default:
            return state;
    }
}
